import styled from "styled-components";
import formatNumber from "../../../../../controllers/utils/formatNumber";
import capitalizeFirstLetter from "../../../../../controllers/capitalizeFirstLetter";
import SecondaryText from "../../../../detailsPage/SecondaryText";
import { useEffect } from "react";

const Container = styled.div``;

export default function ActivityRechargeBillLine({
  type,
  typeIdVsData,
  quantity,
  itemID,
  setAmount,
}) {
  useEffect(() => {
    if (setAmount) {
      setAmount(getPrice());
    }
  }, []);

  let amount = getPrice() * quantity;

  if (!typeIdVsData[itemID]) return `Invalid Activity ${itemID}`;

  return (
    <SecondaryText>
      {typeIdVsData[itemID].title} {capitalizeFirstLetter(type.toLowerCase())} x{" "}
      {quantity} = {formatNumber(amount)} CFA
    </SecondaryText>
  );

  function getPrice() {
    if (type == "SOLO") return typeIdVsData[itemID].price;
    if (type == "PAIR") return typeIdVsData[itemID].pairPrice;
    if (type == "TRIO") return typeIdVsData[itemID].trioPrice;
  }
}
